const services = [
  {
    icon: "ri-building-2-line",
    title: "Gebäudereinigung",
    desc: "Professionelle Innen- und Außenreinigung für Wohn- und Gewerbeimmobilien – regelmäßig und zuverlässig.",
    color: "bg-[#EEF4F0]",
    img: "https://public.readdy.ai/ai/img_res/a83aa5214251309d97c48c24025586eb.jpg",
  },
  {
    icon: "ri-tools-line",
    title: "Hausmeisterservice",
    desc: "Wartung, Reparaturen und Instandhaltung – wir kümmern uns um alles, was Ihr Objekt am Laufen hält.",
    color: "bg-[#F4F0EE]",
    img: "https://readdy.ai/api/search-image?query=professional%20handyman%20facility%20manager%20in%20uniform%20working%20on%20building%20maintenance%20repair%20in%20Germany%2C%20tools%20in%20hand%2C%20clean%20modern%20apartment%20building%20interior%2C%20neutral%20background%2C%20high%20quality%20photography&width=400&height=280&seq=svc002&orientation=landscape",
  },
  {
    icon: "ri-plant-line",
    title: "Grünpflege",
    desc: "Rasenpflege, Heckenschnitt und Bepflanzung – Ihre Außenanlagen immer in bestem Zustand.",
    color: "bg-[#EEF4EE]",
    img: "https://readdy.ai/api/search-image?query=professional%20landscaping%20garden%20maintenance%20service%20workers%20trimming%20hedges%20and%20mowing%20lawn%20at%20residential%20apartment%20complex%20in%20Germany%2C%20green%20lush%20surroundings%2C%20clean%20neat%20garden%2C%20high%20quality%20photography&width=400&height=280&seq=svc003&orientation=landscape",
  },
  {
    icon: "ri-delete-bin-line",
    title: "Entrümpelung",
    desc: "Schnelle und saubere Entrümpelung von Wohnungen, Kellern und Gewerberäumen – diskret und termingerecht.",
    color: "bg-[#F4F4EE]",
    img: "https://readdy.ai/api/search-image?query=professional%20clearance%20service%20team%20clearing%20out%20apartment%20furniture%20and%20belongings%20in%20Germany%2C%20organized%20efficient%20work%2C%20clean%20empty%20room%20result%2C%20neutral%20light%20background%2C%20high%20quality%20commercial%20photography&width=400&height=280&seq=svc004&orientation=landscape",
  },
  {
    icon: "ri-hammer-line",
    title: "Renovierung & Sanierung",
    desc: "Von der Schönheitsreparatur bis zur Kernsanierung – wir bringen Ihre Immobilie auf den neuesten Stand.",
    color: "bg-[#EEF0F4]",
    img: "https://readdy.ai/api/search-image?query=professional%20renovation%20and%20refurbishment%20of%20apartment%20in%20Germany%2C%20workers%20painting%20walls%20and%20installing%20flooring%2C%20modern%20clean%20renovation%20result%2C%20bright%20interior%2C%20high%20quality%20commercial%20photography%2C%20neutral%20tones&width=400&height=280&seq=svc005&orientation=landscape",
  },
];

export default function SolutionSection() {
  return (
    <section id="leistungen" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-4 block">Unsere Leistungen</span>
          <h2 className="text-4xl md:text-5xl font-bold text-black leading-tight mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
            Alles aus einer Hand
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Wir übernehmen die komplette Betreuung Ihrer Objekte – zuverlässig, strukturiert und ohne ständiges Nachfassen.
          </p>
        </div>

        {/* Service Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <div
              key={i}
              className={`rounded-2xl overflow-hidden group cursor-pointer transition-all duration-300 hover:-translate-y-1 ${
                i === 4 ? "sm:col-span-2 lg:col-span-1" : ""
              }`}
            >
              <div className="relative overflow-hidden h-48">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>
              <div className={`${s.color} p-6`}>
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white">
                    <i className={`${s.icon} text-black text-base`}></i>
                  </div>
                  <h3 className="font-bold text-black text-lg">{s.title}</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Badge */}
        <div className="flex justify-center mt-10 md:mt-12 px-4">
          <div className="inline-flex items-center gap-3 bg-black text-white px-5 py-3 rounded-full text-sm font-semibold text-center">
            <i className="ri-shield-check-line text-green-400 flex-shrink-0"></i>
            <span>Ein Ansprechpartner für alle Leistungen</span>
          </div>
        </div>
      </div>
    </section>
  );
}
